import React from 'react';

import SellInfo from '../../order/components/SellItem/SellInfo';
import { useOrderManagement } from '../useOrderManagement';

export function SellRequest({ item }) {
  const {selectedSellRequests, onSelectSellRequest} = useOrderManagement();

  return (
    <div
      key={item.id}
      className={`order-item ${selectedSellRequests[item.id] ? 'selected' : ''}`}
      onClick={() => onSelectSellRequest(item)}
    >
      <SellInfo
        {...{
          item,
          noStar: true,
        }}
      />
    </div>
  );
};
